// extracted by mini-css-extract-plugin
module.exports = {"newsoverview":"NewsOverview_newsoverview__6a3qj","newsoverview-item":"NewsOverview_newsoverview-item__AcFpQ"};